const BASE_SIZE = 16;
const POINT = 4;

const spaces: { [key: number]: string } = {};

for (let i = 0.5; i <= 100; i += 0.5) {
  spaces[i] = `${(i * POINT) / BASE_SIZE}rem`;
  spaces[-i] = `-${(i * POINT) / BASE_SIZE}rem`;
}

export const space = {
  px: "1px",
  "2px": "2px",
  xs: "0.5rem",
  s: "1rem",
  m: "1.5rem",
  l: "2rem",
  xl: "2.5rem",
  "2xl": "3rem",
  "3xl": "4rem",
  "4xl": "5rem",
  ...spaces,
};
